import React from 'react'
import { TextProps } from './Text.types'
import { StyledText } from './Text.styles'

const defaultTags = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  body1: 'p',
  body2: 'p',
  caption: 'span',
  overline: 'span',
} as const

export const Text: React.FC<TextProps> = ({
  variant = 'body1',
  weight = 'normal',
  align = 'left',
  color = 'primary',
  italic = false,
  underline = false,
  truncate = false,
  className,
  style,
  children,
  as,
}) => {
  const Component = as || defaultTags[variant]

  return (
    <StyledText
      as={Component as any}
      $variant={variant}
      $weight={weight}
      $align={align}
      $color={color}
      $italic={italic}
      $underline={underline}
      $truncate={truncate}
      className={className}
      style={style}
    >
      {children}
    </StyledText>
  )
}
